import {inject, Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {GifCategoryResponse, GifTrendingResponse, GifResult} from '@models';
import {TranslateHelperService} from './translate-helper.service';

@Injectable({
	            providedIn: 'root'
            })
export class GiphyService {

	private apikey = environment.firebase.apiKey;
	private clientkey = '963652012004-ml17dmg8726aljp330r78tekahr0pieq.apps.googleusercontent.com';
	private lmt = 20;
	private translateService: TranslateHelperService = inject(TranslateHelperService);

	constructor() {
	}

	private async httpGetAsync<T>(theUrl: string): Promise<T> {
		const response = await fetch(theUrl, {credentials: 'omit'});
		if (!response.ok) {
			throw new Error(`Giphy request failed: ${response.status} ${response.statusText}`);
		}
		return response.json() as Promise<T>;
	}

	getDomain() {
		return 'https://tenor.googleapis.com';
	}

	getKey() {
		return 'key=' + this.apikey;
	}

	getUrl(endpoint: string) {
		return this.getDomain() + '/v2/' + endpoint + '?' + this.getKey() + '&client_key=' + this.clientkey + '&limit=' + this.lmt + '&locale=' + this.translateService.currentLang + '_' + this.translateService.currentLang.toUpperCase();
	}

	getCategories(): Promise<GifCategoryResponse> {
		return this.httpGetAsync<GifCategoryResponse>(this.getUrl('categories'));
	}

	getTrendGif(path: string): Promise<GifTrendingResponse<GifResult>> {
		return this.httpGetAsync<GifTrendingResponse<GifResult>>(this.getDomain() + path + '&' + this.getKey() + '&limit=50');
	}

	searchGif(searchQuery: string): Promise<GifTrendingResponse<GifResult>> {
		return this.httpGetAsync<GifTrendingResponse<GifResult>>(this.getUrl('search') + '&q=' + searchQuery);
	}
}
